var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4","key":0}),React.createElement("polyline",{"points":"16 17 21 12 16 7","key":1}),React.createElement("line",{"x1":"21","y1":"12","x2":"9","y2":"12","key":2})]);
}

Logout.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-log-out"};

module.exports = Logout;

Logout.default = Logout;
